// extracted by mini-css-extract-plugin
export var label = "_df-5";
export var slideContainer = "_df-0";
export var slider = "_df-1";
export var sliderLg = "_df-4";
export var sliderMd = "_df-3";
export var sliderSm = "_df-2";